<template>
	<div class="banner">
		<div class="container">
			<div class="row banner-text">
				<div class="slider-info col-lg-6">
					<div class="agileinfo-logo pl-2">
						<h2>机器人编程 </h2>
						<h4>全国青少年机器人技术等级考试</h4>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 顺应国家战略培养关键人才</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 理论与实操结合，相辅相成</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 专业教具，玩中学，学中练</p>
					</div>
					<a @click="to1" class="btn mr-3 text-capitalize ml-2" href="javascript:void(0)">考试测评</a>
					<a @click="to2" class="btn mr-3 text-capitalize" href="javascript:void(0)">行业新闻</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'RobotBanner',
		methods: {
			to1() {
				this.$router.push({
					path: '/robot/test'
				})
			},
			to2() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {}
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/css/robot/components/RobotBanner.scss';
</style>